import { action, extendObservable } from 'mobx';
import orderBy from 'lodash/orderBy';
import FetchService from '../../../core/services/FetchService';
import CreateMasteryTestItemDraftDialogService from './CreateMasteryTestItemDraftDialogService';
import ConfirmationDialogService from '../../../core/services/ConfirmationDialogService';
import NotificationService from '../../../core/services/NotificationService';

class MasteryTestListItemsService {
  fetch = new FetchService();
  submit = new FetchService();

  constructor() {
    extendObservable(this, {
      items: [],
      masteryTestId: null,
    });
  }

  init = action((masteryTestId) => {
    this.masteryTestId = masteryTestId;
    this.items = [];
    this.handleLoad();
  });

  handleLoad = action(() => {
    this.fetch
      .fetch({
        url: `/mastery-tests/${this.masteryTestId}/items`,
      })
      .then(() => {
        if (this.fetch.data) {
          this.items = orderBy(this.fetch.data, ['order'], ['asc']);
        } else {
          this.items = [];
        }
      });
  });

  handleOrderChange = action((itemId, order) => {
    this.submit
      .fetch({
        url: `/mastery-tests/${this.masteryTestId}/items/${itemId}`,
        method: 'put',
        body: {
          order,
        },
      })
      .then(() => {
        this.handleLoad();
      });
  });

  handleEdit = (masteryTestItem) => {
    CreateMasteryTestItemDraftDialogService.handleShow(masteryTestItem);
  };

  handlePublish = action((masteryTestItem) => {
    ConfirmationDialogService.show(
      'Publish Draft Item',
      `Do you really want to publish the draft item with data "Order: ${masteryTestItem.order}, Text: ${masteryTestItem.item.text}"?`,
      () => {
        this.submit
          .fetch({
            method: 'patch',
            url: `/mastery-tests/${masteryTestItem.masteryTest}/items/${masteryTestItem.item.id}/publish`,
          })
          .then(() => {
            if (this.submit.data) {
              NotificationService.addNotification('Draft item published successfully', 'success');
              this.handleLoad();
            }
            if (this.submit.error) {
              NotificationService.addNotification(this.submit.error || `Error to publish draft item`, 'error');
            }
          });
      }
    );
  });

  handleUnpublish = action((masteryTestItem) => {
    ConfirmationDialogService.show(
      'Unpublish Item',
      `Do you really want to unpublish the item with data "Order: ${masteryTestItem.order}, Text: ${masteryTestItem.item.text}"?`,
      () => {
        this.submit
          .fetch({
            method: 'patch',
            url: `/mastery-tests/${masteryTestItem.masteryTest}/items/${masteryTestItem.item.id}/unpublish`,
          })
          .then(() => {
            if (this.submit.data) {
              NotificationService.addNotification('Draft item unpublished successfully', 'success');
              this.handleLoad();
            }
            if (this.submit.error) {
              NotificationService.addNotification(this.submit.error || `Error to publish draft item`, 'error');
            }
          });
      }
    );
  });
}

const masteryTestListItemsService = new MasteryTestListItemsService();

export default masteryTestListItemsService;
